import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {usePenghargaanListModel} from "@/stores/models/penghargaan-list-model";

export const usePenghargaanListStore  = defineStore(
    'penghargaanListStore',
    () => {
       
        const isLoading = ref(false);
        const selectedPegawai = ref(null);
        const dataSourcePenghargaanList = ref(
            new DataSource({
                requireTotalCount: true,
                store: usePenghargaanListModel().penghargaanListCustomStore,
                filter: null,
            })
        );

        // const dataSourcePendidikanList = (additionalParams = null) => {
        //     // console.log('masuk dataSourcePendidikanList', additionalParams)
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePendidikanListModel().pendidikanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourcePenghargaanList.value.reload();
        };

        const initialized = ()=>{     
            dataSourcePenghargaanList.value.reload();
        };

        return {
            dataSourcePenghargaanList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            selectedPegawai

        }
    }
);